import { createClient } from "@supabase/supabase-js";
import { supaBaseDbUrl } from "./constants";

const client = createClient(
  supaBaseDbUrl,
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZ1cG1kZmZkcnFneXVjdWFkc3BzIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzU2MjgxMzUsImV4cCI6MjA1MTIwNDEzNX0.BGtAOBu70rl8oWlFI8GjKmiSSHsHj97YRlQV3XklNps"
);

const supabase = () => client;

export { supabase };
